
import { mergeMap } from 'rxjs/operators'
import { combineEpics } from 'redux-observable'
import { Epic } from 'interfaces/middleware'
import { HANDLE_UNAUTHORIZED_ERROR, SET_UNEXPECTED_ERROR, resetStateActionCreator } from 'actions/globalActions'
import { captureException } from 'helpers/errorHelpers'
import { LOGIN_URL } from 'tangle-shared'
import { empty, from } from 'rxjs'
import { loggedOutActionCreator } from 'actions/authActions'
import { IS_STATUS_APP } from 'helpers/userAgentHelpers'
import { byType } from 'rxOperators/byType'
import { end } from 'rxOperators/end'

const captureErrorEpic: Epic = (action$) =>
  action$
    .pipe(byType(SET_UNEXPECTED_ERROR))
    .pipe(end(({ payload }) => {
      const { internalError } = payload
      if (internalError) {
        captureException(internalError)
      }
    }))

const handleUnauthorizedErrorEpic: Epic = (action$) =>
  action$
    .pipe(byType(HANDLE_UNAUTHORIZED_ERROR)).pipe(
      mergeMap(() => {
        const actions = [loggedOutActionCreator()]

        if (!IS_STATUS_APP) {
          if (document.location.pathname === LOGIN_URL) {
            return empty()
          }
        }

        actions.push(
          resetStateActionCreator(() => [
          // `resetState` make a `member.isAuthenticated === null`
          // so we need to set this flag to `false` explicitly once again
            loggedOutActionCreator(),
          ])
        )

        return from(actions)
      }))

export default combineEpics(
  captureErrorEpic,
  handleUnauthorizedErrorEpic,
)
